<template>
  <div class="container">
    <div class="header">
      <img
        src="./assets/Speed-Kit-Logo.svg"
        loading="lazy"
        alt=""
        class="image"
      />
    </div>
    <div class="header-line"></div>
    <div class="main">
      <div class="card">
        <div class="card-headline">Speed Kit Tracking</div>

        <div class="card-text">
          Um die Aggregation und Analyse von Daten zu Ihrem Besuch der
          {{ domain }} Website durch Speed Kit zu deaktivieren, müssen wir einen
          Cookie mit der Bezeichnung speed-kit-rum-opt-out in Ihrem Browser
          installieren. Dieser Cookie identifiziert die Deaktivierung. Wenn Sie
          den Cookie löschen bzw. andere Computer oder Webbrowser verwenden,
          müssen Sie die Deaktivierung erneut durchführen.
        </div>
        <a
          id="opt-out"
          v-if="allowed"
          :href="optOutLink"
          class="card-button w-button"
          >Tracking deaktivieren</a
        >
      </div>
      <div class="footer">
        <a
          href="https://www.baqend.com/privacy/"
          target="_blank"
          class="footer-text"
          >Datenschutz</a
        ><a
          href="https://www.baqend.com/terms/"
          target="_blank"
          class="footer-text"
          >AGB</a
        ><a
          href="https://www.baqend.com/imprint/"
          target="_blank"
          class="footer-text"
          >Impressum</a
        >
      </div>
    </div>
  </div>
</template>
<style>
.container {
  width: 100%;
}
</style>
<script>
export default {
  name: "App",
  data() {
    return {
      optOutLink: null,
      domain: null,
      allowed: false,
    };
  },
  mounted() {
    const href = new URL(location.href);
    const params = new URLSearchParams(href.search);
    const optOutLink = new URL(params.get("url"));
    this.allowed =
      !document.referrer ||
      new URL(document.referrer).hostname === optOutLink.hostname;
    if (this.allowed) {
      optOutLink.hash = "speed-kit-rum-opt-out=1";
      this.optOutLink = optOutLink.href;
      this.domain = optOutLink.hostname;
    }
  },
};
</script>
